
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7898"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7898"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $8l2wg = parcelRequire("8l2wg");

var $gAi0s = parcelRequire("gAi0s");

var $g65ub = parcelRequire("g65ub");

var $a8V6k = parcelRequire("a8V6k");
let $3fff45e6e5d8bfec$var$startTimestamp = null;
let $3fff45e6e5d8bfec$var$endTimestamp = null;
const $3fff45e6e5d8bfec$var$setEndTimestamp = (timestamp)=>{
    $3fff45e6e5d8bfec$var$endTimestamp = timestamp;
    document.getElementById("timer-results").setAttribute("data-time", "" + ($3fff45e6e5d8bfec$var$endTimestamp - $3fff45e6e5d8bfec$var$startTimestamp));
};
(0, $a8V6k.onReset)(()=>{
    $3fff45e6e5d8bfec$var$startTimestamp = null;
    $3fff45e6e5d8bfec$var$endTimestamp = null;
    document.getElementById("timer-results").removeAttribute("data-time");
});
const $3fff45e6e5d8bfec$var$handleInputInteraction = (event)=>{
    if ($3fff45e6e5d8bfec$var$startTimestamp === null) $3fff45e6e5d8bfec$var$startTimestamp = event.timeStamp;
};
window.addEventListener((0, $8l2wg.DATE_CHANGE_EVENT_NAME), (event)=>{
    const date = event.detail;
    if ($3fff45e6e5d8bfec$var$endTimestamp === null && (0, $gAi0s.checkDate)(date)) $3fff45e6e5d8bfec$var$setEndTimestamp(event.timeStamp);
});
(0, $g65ub.onInit)(()=>{
    const input = document.querySelectorAll("input, select");
    const events = [
        "focus",
        "blur",
        "change",
        "input"
    ];
    for (const el of Array.from(input))for (const event of events)el.addEventListener(event, $3fff45e6e5d8bfec$var$handleInputInteraction);
});


//# sourceMappingURL=index.eec1aa04.js.map
